import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['modal', 'overlay'];
  
  connect() {
    this.storageKey = 'phase_change_alert_last_shown';
    
    if (this.shouldShowModal()) {
      this.showModal();
    }
  }
  
  shouldShowModal() {
    const today = new Date();

    // 月末7日間でない場合は表示しない
    if (!this.isLastSevenDaysOfMonth(today)) {
      return false;
    }

    // 今日既に表示済みの場合は表示しない（1日1回）
    const lastShownDateStr = localStorage.getItem(this.storageKey);
    if (lastShownDateStr) {
      const lastShownDate = new Date(lastShownDateStr);
      if (today.toDateString() === lastShownDate.toDateString()) {
        return false;
      }
    }

    // 月末7日間かつ今日未表示の場合のみ表示
    return true;
  }
  
  isLastSevenDaysOfMonth(date) {
    // 月末日を取得（次の月の0日 = 当月の最終日）
    const lastDayOfMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
    const currentDay = date.getDate();

    // 年末年始の兼ね合いで企業は管理画面を見ない為、2025年の年末は前倒しでモーダル表示
    // その期間を判定するためのメソッド
    const yearEndModalStartDate = new Date(2025, 11, 22);
    const yearEndModalEndDate = new Date(2026, 0, 1);

    const isYearEndModalPeriod = date >= yearEndModalStartDate && date < yearEndModalEndDate;

    // 月末10日間かどうか判定
    if(isYearEndModalPeriod){
      return currentDay >= (lastDayOfMonth - 11);
    }

    // 月末7日間かどうか判定
    return currentDay >= (lastDayOfMonth - 6);
  }

  showModal() {
    if (this.hasModalTarget && this.hasOverlayTarget) {
      this.modalTarget.classList.remove('is-hide');
      this.modalTarget.classList.add('is-show');
      this.overlayTarget.classList.remove('is-hide');
      this.overlayTarget.classList.add('is-show');
      
      localStorage.setItem(this.storageKey, new Date().toISOString());
    }
  }
  
  close() {
    if (this.hasModalTarget && this.hasOverlayTarget) {
      this.modalTarget.classList.remove('is-show');
      this.modalTarget.classList.add('is-hide');
      this.overlayTarget.classList.remove('is-show');
      this.overlayTarget.classList.add('is-hide');
    }
  }
}